export const profileStyles = {
  page: {
    p: {
      xs: 2,
      md: 3,
    },
  },

  card: {
    maxWidth: 760,
    mx: "auto",
  },

  title: {
    mb: 1,
  },

  subtitle: {
    mb: 3,
  },

  error: {
    mb: 3,
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 1,
  },

  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 300,
  },
};
